import PropTypes from 'prop-types';
import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIosRounded';
import CallMadeIcon from '@mui/icons-material/CallMadeRounded';
import capitalize from '@mui/material/utils/capitalize';
import { StyledLinks } from './styled';

const LinkItem = ({ label, link, isActive, newTab }) => {
  return (
    <li>
      <StyledLinks
        to={link}
        activeClassName="flowDetailsNavActive"
        exact
        $newTab={newTab}
        {...(isActive && { isActive })}
        {...(newTab && { target: '_blank' })}
      >
        {capitalize(label || '')}
        {newTab ? <CallMadeIcon /> : <ArrowForwardIosIcon />}
      </StyledLinks>
    </li>
  );
};

LinkItem.propTypes = {
  isActive: PropTypes.func,
  newTab: PropTypes.bool,
  label: PropTypes.string.isRequired,
  link: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
};

LinkItem.defaultProps = {
  isActive: undefined,
  newTab: false,
};

export default LinkItem;
